import { jwtDecode } from 'jwt-decode';
import memoize from 'memoize-one';

const memoizedJwtDecode = memoize(jwtDecode);

/**
 * This method for getting the expiration Date of the access token
 *
 * @environments client
 * @returns the expiration Date
 */
export const getAccessTokenExpiration = (accessToken?: string): Date => {
  if (!accessToken) {
    throw new Error('No access token');
  }

  // Doesn't seem like much but each jwt-decode takes 1-10ms
  const decoded = memoizedJwtDecode(accessToken);
  const decodedToken =
    typeof decoded === 'object' && decoded !== null
      ? (decoded as { exp?: number })
      : {};
  const expires = decodedToken.exp ?? 0;
  const expiresAt = new Date(expires * 1000);
  if (!expiresAt) {
    throw new Error('No expiration found in access token');
  }
  return expiresAt;
};
